export const outcomeDiaryKeys = {
  getOne: (id: string) => ["outcomeDiary", id] as const,
  getInsight: (id: string) => ["outcomeDiaryInsight", id] as const,
};
